export default {
    methods: {
        /**
         * 无埋点大数据统计
         * @param url Ajax访问URL
         * @param data 字符串数据
         */
        $buriedFreeStatistics(url = '', data = {}) {

            const bigData_json = this.$qs.stringify(data);// 大数据JSON
            // 发送数据时间
            const bigData_endTime = new Date().getTime();
            // 大数据发送
            this.$ajax({
                url: '/HandlerBD.ashx',
                autoCancel: false,
                bigData: false,
                data: {
                    act: 'bigData',
                    bigDataUser: this.$getCookie('cookieName') || '',// 用户名
                    bigDataUrl: url,// 获取路由路径
                    bigDataAllUrl: window.location.href.toLowerCase(),// 获取完整路径
                    bigDataNav: navigator.userAgent,// 浏览器信息
                    bigDataJson: bigData_json,// 大数据JSON
                    bigDataFirstTime: this.$store.state.bigData_firstTime,// 进入当前页面的时间
                    bigDataTime: bigData_endTime - this.$store.state.bigData_startTime// 距离上一次发送间隔时间
                }
            });
            // 发送完毕
            this.$store.commit('bigDataStartTime', bigData_endTime);
        }
    }
};